import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInvite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"invite, briefing"} maskId="square-filled-radius-0-stroke-1-IconInvite"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V10.4493L22 9.81777V21H2V9.81777L4 10.4493V2ZM5 10.7651L12 12.9757L19 10.7651V3H5V10.7651ZM9 7H15V8H9V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconInvite;
